import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";

function Achievements() {
    const navigate = useNavigate();

    return (
        <main className="material-page">
            <section className="section section-surface">
                <div className="container">
                    <p className="eyebrow">ACHIEVEMENTS</p>
                    <h2>Performance Records</h2>

                    <section className="achievement-highlight-section">

                        <div className="achievement-highlight">

                            <div className="achievement-highlight-image">
                                <img src="/gallery/1.jpg" alt="Guinness World Record performance" />
                            </div>

                            <div className="achievement-highlight-content">
                                <p className="eyebrow">GUINNESS WORLD RECORDS</p>

                                <h3>Students Achieving Global Recognition</h3>

                                <p>
                                    Chennai Hoopers students have achieved more than 75 Guinness World
                                    Records through disciplined training and consistent performance.
                                    These records span endurance, precision control, synchronized routines,
                                    and high-speed hooping techniques.
                                </p>

                                <p>
                                    Many students have set records at a young age, demonstrating
                                    dedication, coordination, and mental focus.
                                </p>

                                <button
                                    className="btn-primary"
                                    onClick={() => navigate("/achievements/gwr")}
                                >
                                    Explore Guinness World Records
                                </button>

                            </div>

                        </div>


                        <div className="achievement-highlight reverse">

                            <div className="achievement-highlight-image">
                                <img src="/gallery/2.jpg" alt="Rhythmic gymnastics training" />
                            </div>

                            <div className="achievement-highlight-content">
                                <p className="eyebrow">RHYTHMIC GYMNASTICS</p>

                                <h3>Performance and Artistic Excellence</h3>

                                <p>
                                    Rhythmic gymnastics training at Chennai Hoopers focuses on
                                    flexibility, musical timing, body control, and apparatus handling.
                                </p>

                                <p>
                                    Students develop strong fundamentals in ribbon, hoop, and rhythmic
                                    choreography, preparing them for competitive performances and
                                    artistic showcases.
                                </p>

                                <button
                                    className="btn-primary"
                                    onClick={() => navigate("/achievements/rhythmic")}
                                >
                                    Explore Rhythmic Achievements
                                </button>

                            </div>

                        </div>

                    </section>
                </div>
            </section>
        </main>
    );
}

export default Achievements;